import { ActionMatchingPattern } from '@redux-saga/types';
import { without } from 'lodash';
import { Middleware } from 'redux';
import { ActionPattern } from 'redux-saga/effects';
import { rootReducer } from 'store/reducer';

const rbEventNameToNumber: Record<string, number[]> = {};
const rbEventNumberToName: Record<number, string> = {};
const rbEventNumberToFunction: Record<number, CallableFunction> = {};
let rbEventsCounter = 0;

export const eventMiddleware: Middleware<
  {}, // Most middleware do not modify the dispatch return value
  ReturnType<typeof rootReducer>
> = () => (next) => (action) => {
  rbEventNameToNumber[action.type]?.forEach((eventNumber) =>
    rbEventNumberToFunction[eventNumber]?.(action),
  );
  return next(action);
};

export function doAddEvent<P extends ActionPattern>(
  pattern: P,
  worker: (action: ActionMatchingPattern<P>) => void,
): number {
  const name = pattern.toString();
  rbEventsCounter += 1;
  if (rbEventNameToNumber[name]) {
    rbEventNameToNumber[name]?.push(rbEventsCounter);
  } else {
    rbEventNameToNumber[name] = [rbEventsCounter];
  }
  rbEventNumberToName[rbEventsCounter] = name;
  rbEventNumberToFunction[rbEventsCounter] = worker;
  return rbEventsCounter;
}

export function doRemoveEvent(eventNumber: number) {
  const name = rbEventNumberToName[eventNumber];
  if (name) {
    rbEventNameToNumber[name] = without(rbEventNameToNumber[name], eventNumber);
    if (rbEventNameToNumber[name]?.length === 0) {
      delete rbEventNameToNumber[name];
    }
    delete rbEventNumberToName[eventNumber];
    delete rbEventNumberToFunction[eventNumber];
  }
}

export function doRemoveEvents(eventNumbers: number[]) {
  eventNumbers.map(doRemoveEvent);
}
